

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, KeyValue, Grid } from 'web-library';
import { useTranslation } from 'react-i18next';
import FormHeader from '../../../../components/form-items/FormHeader';
import { CandidateDetailsInSummary } from "../../../../api/candidate/appeal/model"

const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(2),
    maxWidth: 960,
  },
}));


const PersonalDetails = ({ ...props }: CandidateDetailsInSummary) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <FormHeader title={t('appeal->>AppealSummary.CandidateDetails.CandidateDetails')} />

      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            id="candidateName"
            keyText={t('appeal->>AppealSummary.CandidateDetails.Name')}
            valueText={props.statutoryName}
          />
        </Grid>
      </Grid>

      <Grid container direction="row">
        <Grid md={6} sm={12}>
          <KeyValue
            id="nricFinPassport"
            keyText={t('appeal->>AppealSummary.CandidateDetails.NRIC')}
            valueText={props.nricFin}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="citizenship"
            keyText={t('appeal->>AppealSummary.CandidateDetails.Citizenship')}
            valueText={props.citizenship}
          />
        </Grid>
      </Grid>


      <Grid container direction="row">
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="school"
            keyText={t('appeal->>AppealSummary.CandidateDetails.School')}
            valueText={props.schoolName}
          />
        </Grid>
        <Grid md={6} sm={12} xs={12}>
          <KeyValue
            id="indexNo"
            keyText={t('appeal->>AppealSummary.CandidateDetails.IndexNo')}
            valueText={props.indexNo}
          />
        </Grid>
      </Grid>


    </Box>
  );
};

export default PersonalDetails;
